import * as Yup from 'yup';
import i18n from 'i18n';

const passwordRequirementsMessage = i18n.t('Forms.Validation.PasswordRequirements', {
    format: i18n.t('Forms.Validation.PasswordInstruction'),
});

// The phone number is digits only, country code included. Standard signup takes US/Canada numbers
// (1 + 10 digits). With `allowInternationalPhone` (Signature Collection) any country code is
// accepted: 7 to 15 digits (15 is the E.164 maximum), not starting with 0.
const US_CANADA_PHONE = /^1\d{10}$/;
const INTERNATIONAL_PHONE = /^[1-9]\d{6,14}$/;

const vendorBasicDetailsFormSchemaWrapper = ({ allowInternationalPhone = false } = {}) => {
    const vendorBasicDetailsFormSchema = Yup.object()
        .shape({
            Firstname: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    /^[A-Za-z\s]*$/,
                    i18n.t('Name should not contain any special characters or numbers', {
                        field: i18n.t('Forms.Labels.Firstname'),
                    })
                )
                .required(i18n.t('Forms.Validation.NameRequired')),
            Lastname: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    /^[A-Za-z\s]*$/,
                    i18n.t('Name should not contain any special characters or numbers', {
                        field: i18n.t('Forms.Labels.Firstname'),
                    })
                )
                .required(i18n.t('Forms.Validation.NameRequired')),
            Emailaddress: Yup.string()
                .email(i18n.t('Forms.Validation.ValidEmail'))
                .required(i18n.t('Forms.Validation.EmailRequired')),
            Phonenumber: Yup.string()
                .max(
                    120,
                    i18n.t('Forms.Validation.CannotExceedCharacterLimit', {
                        characterLimit: '120',
                    })
                )
                .matches(
                    allowInternationalPhone ? INTERNATIONAL_PHONE : US_CANADA_PHONE,
                    i18n.t(
                        allowInternationalPhone
                            ? 'Forms.Validation.PhonenumInvalidInternational'
                            : 'Forms.Validation.PhonenumInvalid'
                    )
                )
                .required(i18n.t('Forms.Validation.PhonenumRequired')),
            Enterpassword: Yup.string()
                .required(i18n.t('Forms.Validation.PasswordRequired'))
                .min(8, passwordRequirementsMessage)
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])[A-Za-z\d\S]{8,}$/,
                    passwordRequirementsMessage
                ),
            Confirmpassword: Yup.string()
                .required(i18n.t('Forms.Validation.ConfirmPasswordRequied'))
                .oneOf([Yup.ref('Enterpassword')], i18n.t('Forms.Validation.PasswordsMustMatch')),
            Agree: Yup.bool().oneOf([true], i18n.t('Forms.Labels.SignupAgreement')),
        })
        .required();

    return vendorBasicDetailsFormSchema;
};

export { vendorBasicDetailsFormSchemaWrapper, US_CANADA_PHONE, INTERNATIONAL_PHONE };
